import { create } from './object';
export var memoize = function memoize(fn) {
  var cache = create(null);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsKey = JSON.stringify(args);
    return cache[argsKey] = cache[argsKey] || fn.apply(null, args);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/memoize.js
// module id = 278
// module chunks = 1